import { useFileContent } from '@/api-models/sandbox-files';
import { SegmentedControl } from '@/ui/SegmentedControl';
import { Spinner } from '@/ui/Spinner';

import { AssistantMarkdown } from '../../thread/AssistantMarkdown';

import { CodeViewer } from './CodeViewer';

interface FileTabPaneProps {
  base: string;
  path: string;
  active: boolean;
  isPreview: boolean;
  onPreviewChange: (isPreview: boolean) => void;
}

export function FileTabPane({ base, path, active, isPreview, onPreviewChange }: FileTabPaneProps) {
  const { content, isLoading } = useFileContent(base, path);
  const isMarkdown = path.toLowerCase().endsWith('.md');
  const showPreview = isMarkdown && isPreview;

  return (
    <div className="absolute inset-0 flex flex-col" style={{ display: active ? 'flex' : 'none' }}>
      {isLoading || content === null ? (
        <div className="flex flex-1 items-center justify-center">
          <Spinner size={5} />
        </div>
      ) : (
        <>
          {isMarkdown && (
            <div className="flex h-9 shrink-0 items-center justify-end border-b border-line-subtle px-2">
              <SegmentedControl
                value={showPreview ? 'preview' : 'code'}
                onChange={(value) => onPreviewChange(value === 'preview')}
                options={[
                  { value: 'code', label: 'Code' },
                  { value: 'preview', label: 'Preview' },
                ]}
                ariaLabel="Markdown view"
              />
            </div>
          )}
          {showPreview ? (
            <div className="min-h-0 flex-1 overflow-auto p-4">
              <AssistantMarkdown content={content} />
            </div>
          ) : (
            <CodeViewer path={path} content={content} />
          )}
        </>
      )}
    </div>
  );
}
